import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { ChcpRoute } from '@cigna/chcp/shared/util';
import { FeatureTogglesFacade } from '@cigna/features';
import { Observable, of } from 'rxjs';

@Injectable()
export class FeatureToggleGuard implements CanActivate {
  constructor(private featureTogglesFacade: FeatureTogglesFacade) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const features = (route as ChcpRoute).data?.guards?.features;

    if (!features) {
      return of(true);
    }
    return this.featureTogglesFacade.featuresEnabled(features, 'OR');
  }
}
